const OFFICIAL_ROLES = [
  { type: "Main", prefix: "Referee" },
  { type: "Lineman 1", prefix: "Assistant Referee 1" },
  { type: "Lineman 2", prefix: "Assistant Referee 2" },
  { type: "fourthOfficial", prefix: "Fourth Official" },
  { type: "videoReferee", prefix: "Video Assistant Referee" },
];

export class RefereeAssistants {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "RefereeAssistants";
    this.scene = "Referee Assistants";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    OFFICIAL_ROLES.forEach(({ type, prefix }) => {
      const entry = options.officials?.find((o) => o?.type === type);
      const official = entry?.official;
      this.data.push({
        name: `${prefix} First Name`,
        value: { text: official?.first_name ?? official?.opta_first_name ?? "" },
      });
      this.data.push({
        name: `${prefix} Last Name`,
        value: { text: official?.last_name ?? official?.opta_last_name ?? "" },
      });
      this.data.push({
        name: `${prefix} Full Name`,
        value: {
          text:
            (official?.first_name ?? official?.opta_first_name ?? "") +
            " " +
            (official?.last_name ?? official?.opta_last_name ?? ""),
        },
      });
      this.data.push({
        name: `${prefix} Type`,
        value: { text: entry?.type || "" },
      });
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
